import { useEffect, useRef } from 'react';
import { AppState } from 'react-native';
import { useNavigation } from 'app/hooks/navigation';

export const useOnFocus = (callback: () => void, executeFirst = false) => {
  const navigation = useNavigation();
  const isFirst = useRef<boolean>(true);
  const isFocused = useRef<boolean>(true);
  const lastStatus = useRef<string>('active');
  useEffect(() => {
    const subscription = AppState.addEventListener('change', (status) => {
      if (status === 'active' && lastStatus.current !== 'active' && isFocused.current) {
        callback();
      }
      lastStatus.current = status;
    });
    const unsubscribeOnFocus = navigation.addListener('focus', () => {
      isFocused.current = true;
      const first = isFirst.current;
      isFirst.current = false;
      if (first && !executeFirst) {
        return;
      }
      callback();
    });
    const unsubscribeOnBlur = navigation.addListener('blur', () => {
      isFocused.current = false;
    });
    return () => {
      subscription.remove();
      unsubscribeOnFocus();
      unsubscribeOnBlur();
    };
  }, [callback, executeFirst, navigation]);
};
